import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useState } from "react";
import { useStylesheet } from "../../contexts";
import { extendCommonStylesheet } from "@devowl-wp/web-cookie-banner";
import { useA11yId } from "../../hooks";
const LinkToggle = (param)=>{
    let { onToggle, children, showMore, hideMore, bullets, forceRender, ...rest } = param;
    const { Link } = useStylesheet().extend(...extendCommonStylesheet);
    const [isOpen, setIsOpen] = useState(false);
    const a11yExpanded = useA11yId();
    return /*#__PURE__*/ _jsxs(Fragment, {
        children: [
            bullets && /*#__PURE__*/ _jsx(Fragment, {
                children: "\xa0\xa0•\xa0\xa0"
            }),
            /*#__PURE__*/ _jsx(Link, {
                href: "#",
                onClick: (e)=>{
                    const newOpen = !isOpen;
                    setIsOpen(newOpen);
                    onToggle == null ? void 0 : onToggle(newOpen);
                    e.preventDefault();
                },
                ...children ? {
                    "aria-expanded": isOpen,
                    "aria-controls": a11yExpanded
                } : {},
                ...rest,
                children: isOpen ? hideMore : showMore
            }),
            children && /*#__PURE__*/ _jsx("div", {
                hidden: !isOpen,
                id: a11yExpanded,
                children: (isOpen || forceRender) && children
            })
        ]
    });
};
export { LinkToggle };
